import { render, staticRenderFns } from "./SectionsList.vue?vue&type=template&id=2a34b780"
import script from "./SectionsList.vue?vue&type=script&lang=js"
export * from "./SectionsList.vue?vue&type=script&lang=js"
import style0 from "./SectionsList.vue?vue&type=style&index=0&id=2a34b780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports